/**
 * Invokes the code to assign branding to the app
 */

import BrandingData from './BrandingData';
// adds branding class to an HTML element
document.documentElement.classList.add(`gw-branding-${BrandingData.BRANDING}`);